var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.76 2a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM5.76 8a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM5.76 14a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgMore;